import { useEventConfig } from '@/eventConfig/useEventConfig.ts';
import { translate } from '@/translation/translate.ts';
import { EditDataField } from '@/components/slides/DataSummary/components/EditDataField.tsx';
import moment from 'moment';
import { EditSaveButtons } from '@/components/slides/DataSummary/components/EditSaveButtons.tsx';
import { useSummaryFormField } from '@/components/slides/DataSummary/components/useSummaryFormField.ts';
import { addReqiredMessage } from '@/components/slides/DataSummary/util/addRequiredMessage.ts';
import { useForm } from '@/form/useForm.ts';

export const PersonalInfoSummaryFormUS = () => {
  const { onStartEdit, onCancelEdit, onSave, editMode, isValid } = useSummaryFormField({
    slideIds: ['birthdate', 'bmi'],
  });

  const { getFieldValue } = useForm();

  const { eventConfig } = useEventConfig();
  const s = eventConfig!.slides;

  const birthdateField = addReqiredMessage({
    field: s.birthdate.fields.find(({ name }) => name === 'birthdate'),
    message: s.dataSummary.requiredMessage!,
  });
  const birthdateLabel = translate(birthdateField?.label);
  const birthdateValue = moment(getFieldValue('birthdate') as string).format('MM/DD/YYYY');

  const heightField = addReqiredMessage({
    field: s.bmi.fields.find(({ name }) => name === 'height'),
    message: s.dataSummary.requiredMessage!,
  });
  const heightLabel = translate(heightField?.label);

  const weightField = addReqiredMessage({
    field: s.bmi.fields.find(({ name }) => name === 'weight'),
    message: s.dataSummary.requiredMessage!,
  });
  const weightLabel = translate(weightField?.label);

  const heightInFt = () => {
    const heightSplitted = ((getFieldValue('height') as string) || '1.0').split('.');
    return `${heightSplitted[0]}'${heightSplitted[1]}"`;
  };

  return (
    <div className="summary-card" data-cy={'summary-form-personal-info'}>
      <h2>{translate(s.dataSummary.titles?.personalInfo)}</h2>
      <EditSaveButtons
        editMode={editMode}
        onSave={onSave}
        onStartEdit={onStartEdit}
        onCancelEdit={onCancelEdit}
        isValid={isValid}
      />

      <div className="data">
        <div className={'label'}>{birthdateLabel}</div>
        <div className={'value'}>
          {!editMode && birthdateValue}
          {editMode && <EditDataField field={birthdateField!} slideId={'birthdate'} />}
        </div>

        <div className={'label'}>{heightLabel}</div>
        <div className={'value'}>
          {!editMode && heightInFt()}
          {editMode && <EditDataField field={heightField!} slideId={'bmi'} />}
        </div>

        <div className={'label'}>{weightLabel}</div>
        <div className={'value'}>
          {!editMode && getFieldValue('weight')}
          {editMode && <EditDataField field={weightField!} slideId={'bmi'} />}
        </div>
      </div>
    </div>
  );
};
